import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { toggleClass } from '@opten/dom/toggle-class';
import { debounce } from '@opten/reactive/debounce';

@Component({ className: 'js-double-scroll' })
export class DoubleScrollComponent {
	private scroller: HTMLElement;
	private inner: HTMLElement;

	constructor(private element: HTMLElement) {
		this.scroller = document.createElement('div');
		addClass(this.scroller, 'c-double-scroll');

		this.inner = document.createElement('div');
		this.scroller.appendChild(this.inner);
		this.element.parentElement.insertBefore(this.scroller, this.element);

		this.resize();
		this.scroller.addEventListener(
			'resize',
			debounce(() => this.resize(), 10)
		);

		this.scroller.addEventListener('scroll', e => {
			this.element.scrollLeft = this.scroller.scrollLeft;
		});
		this.element.addEventListener('scroll', e => {
			this.scroller.scrollLeft = this.element.scrollLeft;
		});
	}

	private resize() {
		this.inner.style.width =
			this.element.firstElementChild.clientWidth + 'px';
		toggleClass(
			this.scroller,
			'has-scroll',
			this.element.scrollWidth > this.element.clientWidth
		);
	}
}
